<div class="item-card" [ngClass]="{'item-card--selected': isSelected}">
    <div class="item-card__checkbox" *ngIf="isSelected">
        <vwui-checkbox [checked]="isSelected"></vwui-checkbox>
    </div>
    <div class="item-card__body"><ng-content></ng-content></div>
    <div class="item-card__footer" [ngClass]="{'item-card__footer--empty': itemCardFooter.children.length === 0}" #itemCardFooter><ng-content select="[footer]"></ng-content></div>
</div>
